import { ROUTES } from "@template/types";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "../components/AppLayout";
import { ForgotPasswordPage } from "../pages/auth/ForgotPasswordPage";
import { LoginPage } from "../pages/auth/LoginPage";
import { ResetPasswordPage } from "../pages/auth/ResetPasswordPage";
import { SsoCallbackPage } from "../pages/auth/SsoCallbackPage";
import { FinanceLayout } from "../pages/finance/FinanceLayout";
import { FinanceProvider } from "../pages/finance/FinanceContext";
import { DashboardPage } from "../pages/finance/DashboardPage";
import { AnnualSummaryPage } from "../pages/finance/AnnualSummaryPage";
import { BudgetsPage } from "../pages/finance/BudgetsPage";
import { ActualExpensesPage } from "../pages/finance/ActualExpensesPage";
import { BudgetVsActualPage } from "../pages/finance/BudgetVsActualPage";
import { MonthlyAnalysisPage } from "../pages/finance/MonthlyAnalysisPage";
import { ForecastPage } from "../pages/finance/ForecastPage";
import { RevenuePage } from "../pages/finance/RevenuePage";
import { CashFlowPage } from "../pages/finance/CashFlowPage";
import { ProfitAndLossPage } from "../pages/finance/ProfitAndLossPage";
import { DepartmentBudgetPage } from "../pages/finance/DepartmentBudgetPage";
import { CostCentreBudgetPage } from "../pages/finance/CostCentreBudgetPage";
import { TallyImportPage } from "../pages/finance/TallyImportPage";
import { ApprovalsPage } from "../pages/finance/ApprovalsPage";
import { PeriodControlPage } from "../pages/finance/PeriodControlPage";
import { VersionsPage } from "../pages/finance/VersionsPage";
import { AuditTrailPage } from "../pages/finance/AuditTrailPage";
import { ReportsPage } from "../pages/finance/ReportsPage";
import { SettingsPage } from "../pages/finance/SettingsPage";
import { UsersAccessPage } from "../pages/finance/UsersAccessPage";
import { RolesPermissionsPage } from "../pages/finance/RolesPermissionsPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicOnlyRoute } from "./PublicOnlyRoute";

export function AppRouter() {
  return (
    <Routes>
      <Route
        path={ROUTES.login}
        element={
          <PublicOnlyRoute>
            <LoginPage />
          </PublicOnlyRoute>
        }
      />
      <Route
        path={ROUTES.forgotPassword}
        element={
          <PublicOnlyRoute>
            <ForgotPasswordPage />
          </PublicOnlyRoute>
        }
      />
      <Route
        path={ROUTES.resetPassword}
        element={
          <PublicOnlyRoute>
            <ResetPasswordPage />
          </PublicOnlyRoute>
        }
      />
      <Route path={ROUTES.ssoCallback} element={<SsoCallbackPage />} />

      <Route
        element={
          <ProtectedRoute>
            <FinanceProvider>
              <AppLayout />
            </FinanceProvider>
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to={ROUTES.financeDashboard} replace />} />

        <Route element={<FinanceLayout />}>
          <Route path={ROUTES.financeDashboard} element={<DashboardPage />} />
          <Route path={ROUTES.financeAnnualSummary} element={<AnnualSummaryPage />} />
          <Route path={ROUTES.financeBudgets} element={<BudgetsPage />} />
          <Route path={ROUTES.financeActuals} element={<ActualExpensesPage />} />
          <Route path={ROUTES.financeBudgetVsActual} element={<BudgetVsActualPage />} />
          <Route path={ROUTES.financeMonthlyAnalysis} element={<MonthlyAnalysisPage />} />
          <Route path={ROUTES.financeForecast} element={<ForecastPage />} />
          <Route path={ROUTES.financeRevenue} element={<RevenuePage />} />
          <Route path={ROUTES.financeCashFlow} element={<CashFlowPage />} />
          <Route path={ROUTES.financePnl} element={<ProfitAndLossPage />} />
          <Route path={ROUTES.financeDepartmentBudget} element={<DepartmentBudgetPage />} />
          <Route path={ROUTES.financeCostCentreBudget} element={<CostCentreBudgetPage />} />
          <Route path={ROUTES.financeTallyImport} element={<TallyImportPage />} />
          <Route path={ROUTES.financeApprovals} element={<ApprovalsPage />} />
          <Route path={ROUTES.financePeriodControl} element={<PeriodControlPage />} />
          <Route path={ROUTES.financeVersions} element={<VersionsPage />} />
          <Route path={ROUTES.financeAuditTrail} element={<AuditTrailPage />} />
          <Route path={ROUTES.financeReports} element={<ReportsPage />} />
          <Route path={ROUTES.financeSettings} element={<SettingsPage />} />
          <Route path={ROUTES.financeUsers} element={<UsersAccessPage />} />
          <Route path={ROUTES.financeRoles} element={<RolesPermissionsPage />} />
        </Route>
      </Route>

      <Route path={ROUTES.notFound} element={<NotFoundPage />} />
    </Routes>
  );
}
